import createIcon from '../../createIcon';

/**
 * @component @name ViewArray
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgNUgxOFYxOUgyMVY1Wk0xNyA1SDdWMTlIMTdWNVpNNiA1SDNWMTlINlY1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ViewArray = createIcon('ViewArray', [
  ['path', { d: 'M21 5H18V19H21V5ZM17 5H7V19H17V5ZM6 5H3V19H6V5Z', key: '1hov36' }],
]);

export default ViewArray;
